import { ExclamationCircleFilled, WarningFilled } from '@ant-design/icons';
import type { AlertActivitySeverity } from '@/apis/shipment';
import styles from './AlertSeverityIcon.module.css';

interface AlertSeverityIconProps {
  /** Severity of an open alert; null when nothing needs attention. */
  severity: AlertActivitySeverity | null;
}

/** Red for critical, yellow for at risk, a neutral dot otherwise. */
const AlertSeverityIcon = ({ severity }: AlertSeverityIconProps) => {
  if (severity === 'critical') {
    return (
      <ExclamationCircleFilled
        style={{ color: 'var(--danger)', width: '12px' }}
      />
    );
  }
  if (severity === 'at_risk') {
    return <WarningFilled style={{ color: 'var(--warning)', width: '12px' }} />;
  }
  return <span className={styles.dot} data-testid='alert-severity-none' />;
};

export default AlertSeverityIcon;
